module.exports = __webpack_public_path__ + "static/img/er_mx.f809a01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/er_mx.jpg
// module id = HXlU
// module chunks = 1